import { render, staticRenderFns } from "./FolderLayer.vue?vue&type=template&id=00ae45e7&scoped=true"
import script from "./FolderLayer.vue?vue&type=script&lang=js"
export * from "./FolderLayer.vue?vue&type=script&lang=js"
import style0 from "./FolderLayer.vue?vue&type=style&index=0&id=00ae45e7&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00ae45e7",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/appdata/www/radzs/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('00ae45e7')) {
      api.createRecord('00ae45e7', component.options)
    } else {
      api.reload('00ae45e7', component.options)
    }
    module.hot.accept("./FolderLayer.vue?vue&type=template&id=00ae45e7&scoped=true", function () {
      api.rerender('00ae45e7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/frontend/components/modules/psd-layers/layer-views/FolderLayer.vue"
export default component.exports